import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';

type Return = {
  isGettingOnboardingDetails: boolean;
  onboardUser: (userId: string) => Promise<void>;
};

export const useOnboardUser = (): Return => {
  const { onboardingApi } = useApiClient();
  const { isPending, mutateAsync } = useMutation<void, AxiosError, string>({
    meta: { disableSuccessAlert: true },
    mutationFn: async userId => {
      await onboardingApi.runOnboardingActions(userId);
    },
  });

  return {
    isGettingOnboardingDetails: isPending,
    onboardUser: mutateAsync,
  };
};
